import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CooperationContactFormComponent } from './cooperation-contact-form/cooperation-contact-form.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatOptionModule, MatRippleModule} from '@angular/material/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';



@NgModule({
  declarations: [CooperationContactFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatRippleModule,
    MatOptionModule,
    MatAutocompleteModule
  ]
})
export class CooperationContactModule { }
